export const ServiceStatus = {
    TO_WORK: '285f5dc6-4ec8-407b-9c81-77f6946030bc',
    POSTPONED: '5fa99132-11ca-4ba1-8263-11439103d178',
    WAITING : '8ea8b8c4-e9cd-448a-9ac4-26edd93eda10',
    CLOSED : 'a231a992-e824-4897-972f-3cd9b847525f',
    INPROGRESS : 'bdb3597e-0239-4d87-a327-224bf2798e38',
}